import { setLightness } from "polished";

export const getColor = (color: string) => {
  return {
    main: color,
    hover: setLightness(0.6, color),
  };
};
